import _property from 'lodash/property';
export var ACCOUNT_RECEIVABLE_FLAG_ID = 'enableAccountReceivable';

var dealerName = _property('dealerName');

var dealerAddress = _property('dealerAddress');

var bankDetails = _property('bankDetails');

var companyName = _property('companyName');

var phone = _property('phone');

var dealerEmail = _property('dealerEmail');

var website = _property('website');

var dealerLogos = _property('dealerLogos');

var dealerDisplayName = _property('dealerDisplayName');

var bar = _property('bar');

var timeZone = _property('timeZone');

var dealerLanguage = _property('dealerLanguage');

var oemDealerId = _property('oemDealerId');

var taxDetails = _property('taxDetails'); // Deprecated


var taxConfig = _property('taxConfig');

var deductibleTaxValue = _property('deductibleTaxValue'); // Deprecated


var thirdPartyTaxValue = _property('thirdPartyTaxValue'); // Deprecated


var state = _property('state');

var id = _property('id');

var employeeHrsDisclaimer = _property('employeeHrsDisclaimer');

var manualPaymentCardTypes = _property('manualPaymentCardTypes');

var cardBrandsSupported = _property('cardBrandsSupported');

var supportedOEMs = _property('supportedOEMs');

var mileageMeasure = _property('mileageMeasure');

var corporationType = _property('corporationType');

var accountReceivableFlag = _property(ACCOUNT_RECEIVABLE_FLAG_ID);

var primaryBrand = _property('primaryBrand');

var currency = _property('currency');

var dealerCountryCode = _property('dealerCountryCode');

var tenantId = _property('tenantId');

var taxRegimeConfig = _property('taxRegimeConfig');

var allowCommunicationOnOptOut = _property('allowCommunicationOnOptOut');

var allowCommunicationToUnknown = _property('allowCommunicationToUnknown');

var optOutLinkRequired = _property('optOutLinkRequired');

var preferencesLinkRequired = _property('preferencesLinkRequired');

var privacyPolicy = _property('privacyPolicy');

var shifts = _property('shifts');

var currencySymbol = _property('currencySymbol');

var currencyPrecision = _property('currencyPrecision');

var regionalTemplateId = _property('regionalTemplateId');

var supportedLanguages = _property('supportedLanguages');

var dealerDoingBusinessAsName = _property('dealerDoingBusinessAsName');

var READER = {
  dealerName: dealerName,
  dealerAddress: dealerAddress,
  bankDetails: bankDetails,
  companyName: companyName,
  phone: phone,
  dealerEmail: dealerEmail,
  website: website,
  dealerLogos: dealerLogos,
  dealerDisplayName: dealerDisplayName,
  bar: bar,
  timeZone: timeZone,
  dealerLanguage: dealerLanguage,
  oemDealerId: oemDealerId,
  taxDetails: taxDetails,
  deductibleTaxValue: deductibleTaxValue,
  thirdPartyTaxValue: thirdPartyTaxValue,
  state: state,
  id: id,
  employeeHrsDisclaimer: employeeHrsDisclaimer,
  manualPaymentCardTypes: manualPaymentCardTypes,
  cardBrandsSupported: cardBrandsSupported,
  taxConfig: taxConfig,
  supportedOEMs: supportedOEMs,
  mileageMeasure: mileageMeasure,
  accountReceivableFlag: accountReceivableFlag,
  corporationType: corporationType,
  primaryBrand: primaryBrand,
  currency: currency,
  dealerCountryCode: dealerCountryCode,
  tenantId: tenantId,
  taxRegimeConfig: taxRegimeConfig,
  allowCommunicationOnOptOut: allowCommunicationOnOptOut,
  optOutLinkRequired: optOutLinkRequired,
  preferencesLinkRequired: preferencesLinkRequired,
  privacyPolicy: privacyPolicy,
  shifts: shifts,
  currencySymbol: currencySymbol,
  currencyPrecision: currencyPrecision,
  regionalTemplateId: regionalTemplateId,
  allowCommunicationToUnknown: allowCommunicationToUnknown,
  supportedLanguages: supportedLanguages,
  dealerDoingBusinessAsName: dealerDoingBusinessAsName
};
export default READER;